module.exports = __webpack_public_path__ + "media/神王.55873e9d.mp4";